import api from "services/api";
import { v4 as uuidv4 } from "uuid";

let header = {
  Authorization: "bearer " + localStorage.getItem("teste"),
};


export const getAllEvents = (model) => {
  return (dispatch) => {
    api.get("list-events", header, function (status, data) {
      if (status === 200) {
        dispatch({
          type: "GET_ALL_EVENTS",
          payload: data,
        });
      }
    }); 
  }
};

export const getCalendars = (model) => {
  return (dispatch) => {
    api.get("get-calendars", header, function (status, data) {
      if (status === 200) {
        dispatch({
          type: "GET_ALL_CALENDARS",
          payload: data,
        });
      }
    });
  }
};

export const createEvent = (model) => {
  return (dispatch) => {
    api.post("create-event", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200) {
        
        dispatch({
          type: "CREATE_EVENT",
          payload: data,
        });
      }
    });
  };
}

export const updateEvent = (model) => {
  return (dispatch) => {
    api.post("update-event", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200) {
        
        dispatch({
          type: "UPDATE_EVENT",
          payload: data,
        });
      }
    });
  };
}

export const deleteEvent = (model) => {
  return (dispatch) => {
    api.post("delete-event", header, model, function (status, data) {
      dispatch({
        type: "INIT",
      });
      if (status === 200) {
        
        dispatch({
          type: "DELETE_EVENT",
          payload: uuidv4(),
        });
      }
    });
  };
}
